import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Home from "@/components/views/Home";
import Explore from "@/components/views/Explore";
import SignIn from "@/components/views/SignIn";
import RequestAccess from "@/components/views/RequestAccess";
import ApplicationStatus from "@/components/views/ApplicationStatus";
const ControlPanel = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel"
  );
import AuthActions from "@/components/views/AuthActions";
import TermsOfUse from "@/components/views/TermsOfUse";

// Control panel components
const CPUsers = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/Users"
  );
const CPDatabase = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/Database"
  );
const CPContent = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/Content"
  );
const CPCorresponder = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/Corresponder"
  );
const CPTerms = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/TermsOfUse"
  );
const CPConnection = () =>
  import(
    /* webpackChunkName: "control-panel" */ "@/components/views/ControlPanel/Connection"
  );

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/explore",
    name: "Explore",
    component: Explore,
    beforeEnter: hasDataAccess
  },
  {
    path: "/signin",
    component: SignIn,
    beforeEnter: isNotLoggedIn
  },
  {
    path: "/auth-actions",
    component: AuthActions
  },
  {
    path: "/request-access",
    component: RequestAccess
  },
  {
    path: "/application-status",
    component: ApplicationStatus,
    beforeEnter: isLoggedIn
  },
  {
    path: "/terms",
    component: TermsOfUse
  },
  {
    path: "/control-panel",
    component: ControlPanel,
    beforeEnter: isAdmin,
    children: [
      {
        path: "",
        redirect: "/control-panel/content"
      },
      {
        path: "users",
        component: CPUsers
      },
      {
        path: "database",
        component: CPDatabase
      },
      {
        path: "content",
        component: CPContent
      },
      {
        path: "corresponder",
        component: CPCorresponder
      },
      {
        path: "terms",
        component: CPTerms
      },
      {
        path: "connection",
        component: CPConnection
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// ---- Navigation guards ----
function isAdmin(to, from, next) {
  if (store.state.user && store.state.user.admin) {
    next();
  } else if (store.state.user) {
    next("/");
  } else {
    next("/signin");
  }
}

function hasDataAccess(to, from, next) {
  if (
    store.state.user &&
    (store.state.user.admin ||
      (store.state.user.emailVerified && store.state.user.accessGranted))
  ) {
    next();
  } else if (store.state.user) {
    next("/");
  } else {
    next("/signin");
  }
}

function isLoggedIn(to, from, next) {
  if (store.state.user) {
    next();
  } else {
    next("/signin");
  }
}

function isNotLoggedIn(to, from, next) {
  if (store.state.user) {
    next("/");
  } else {
    next();
  }
}

export default router;
